module.exports = __webpack_public_path__ + "img/percentage-gray.70001175.svg";